import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { IDocumentTypeIndexCategory } from "../../documentTypes/model/DocumentTypeIndexCategory";
import DocumentTypeIndexCategoryParamMapper from "../../documentTypes/service/DocumentTypeIndexCategoryParamMapper";
import DocumentTypeIndexCategoryMapper from "../../documentTypes/service/DocumentTypeIndexCategoryMapper";
import Constants from "../common/Constants";

export default class FindLegalViewIndexesInCategoryInteractor {
  private resource: GetAllResourceEntriesInteractor<IDocumentTypeIndexCategory>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(documentTypeId: number, organisationId: number) {
    return this.resource.execute(
      `/${Constants.endpointBasePath}/${documentTypeId}/${Constants.indexCategoriesPath}`,
      DocumentTypeIndexCategoryMapper,
      DocumentTypeIndexCategoryParamMapper,
      {
        params: { organisationId }
      }
    );
  }
}
